<template>
    <div class="container">
      <app-header title="BOM表配单" />
      <div class="main">
        <img src="@/assets/upload01.png" alt="上传" width="186" height="123" @click="show = true">
        <div class="title">上传BOM表单文件/图片</div>
        <div class="tip">（注意：上传时请在文件/图片里注明：求购人姓名/联系方式/公司名称）</div>
      </div>
      <van-popup v-model="show" round position="bottom" :style="{ height: '30%' }" >
        <div class="popup">
          <div class="item" @click="onNavigate('/bom/file')">
            <img src="@/assets/file.png" alt="文件" width="25" height="25">
            <span class="name">文件</span>
          </div>
          <div class="item" @click="onNavigate('/bom/image')">
            <img src="@/assets/image.png" alt="图片" width="25" height="25">
            <span class="name">图片</span>
          </div>
        </div>
      </van-popup>
    </div>
</template>

<script>
  export default {
    name: "add",
    data(){
        return{
          show: false
        }
    },
    created(){
      const hasToken = localStorage.getItem("Authorization");
      if (!hasToken){
        this.$router.push({path: '/login'})
      }
    },
    methods:{
      onNavigate(url) {
        this.$router.push({
          path: url
        })
      }
    }
  }
</script>

<style lang="less" scoped>
  .container{
    .main{
      height: 500px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .title{
        height:22px;
        font-size:16px;
        font-weight:bold;
        line-height:22px;
        color:rgba(102,102,102,1);
      }
      .tip{
        height:14px;
        font-size:10px;
        font-weight:400;
        line-height:14px;
        color:rgba(254,0,59,1);
      }
    }
    .popup{
      padding: 22px;
      display: inline-flex;
      .item{
        display: flex;
        flex-direction: column;
        text-align: center;
        margin: 0 30px;
        .name{
          margin-top: 8px;
          height:18px;
          font-size:13px;
          font-weight:400;
          line-height:18px;
          color:rgba(102,102,102,1);
        }
      }

    }
  }
</style>



// WEBPACK FOOTER //
// src/views/bom/add.vue